"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DebugType;

(function (DebugType) {
  DebugType["error"] = "error";
  DebugType["info"] = "info";
  DebugType["warn"] = "warn";
})(DebugType = exports.DebugType || (exports.DebugType = {}));